<template>
<v-container fluid>
  <div>
  <v-card>
    <v-col cols="12" sm="6" md="4">
      Trains Attachment Report
    </v-col>
    <v-sheet
          class="pa-1"
          color="blue lighten-5"
        >
    Attachment upto now:
    <v-row class="mx-auto h4">
      <v-col>
        <v-chip color="green" dark> Before sch. Dep : {{summary[0].before_dep_time}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="orange" dark>After sch. Dep : {{summary[0].after_dep_time}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="red" dark>Not attached : {{summary[1].no_of_train - (summary[0].before_dep_time + summary[0].after_dep_time)}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="blue" dark>Total Trains : {{summary[1].no_of_train}}</v-chip>
      </v-col>
    </v-row>
  </v-sheet>
  <v-sheet
        class="pa-1"
        color="grey lighten-4"
      >
    Attachment over day:
    <v-row class="mx-auto h4">
      <v-col>
        <v-chip color="green" dark> Before sch. Dep : {{summary_all[0].before_dep_time}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="orange" dark>After sch. Dep : {{summary_all[0].after_dep_time}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="red" dark>Not attached : {{summary_all[1].no_of_train - (summary_all[0].before_dep_time + summary_all[0].after_dep_time)}}</v-chip>
      </v-col>
      <v-col>
        <v-chip color="blue" dark>Total Trains : {{summary_all[1].no_of_train}}</v-chip>
      </v-col>
    </v-row>
    </v-sheet>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="train_date" required :rules="dateRules" prepend-icon="event" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="train_date" no-title @input="initialize(false)"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table :headers="headers" :items="trains" :search="search" item-key="train_date+ train_no+name" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50, 100,900]
    }" :items-per-page="40" sort-by="trains" class="elevation-1"
     :loading="isLoading" loading-text="Loading... Please wait" :mobile-breakpoint="100">
     <template v-slot:item.id="{ item }">
       {{trains.map(function(x) {
     return x.id;
     }).indexOf(item.id)+1}}
     </template>
      <template v-slot:item.dep="{ item }">
        {{getFormattedTime(item.dep)}}
      </template>
      <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template>
      <template v-slot:item.insert_lag="{ item }">
        <v-chip :color="getColour(item)" dark>
        {{getFormattedTimeSec(item.insert_lag)}} </v-chip>
      </template>
      <template v-slot:item.insert_time_local="{ item }">
        {{getFormattedDateTime(item.insert_time_local)}}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn v-if ="!item.device_id" text icon color="purple" dark @click.native.stop="addrake(item)">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>

        <v-btn v-if="item.device_id" text icon color="blue" dark @click.native.stop="editTrains(item)">
          <v-icon dark>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="item.device_id" text icon color="green" dark @click.native.stop="onRowClick(item)">
          <v-icon dark>mdi-information</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize(true)">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card>
</div>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'attachment_report',
  components: {
    MaskedInput
  },
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      headers: [
        {
            text: 'Srl',
            align: 'left',
            sortable: true,
            value: 'id',
        },
        {
          text: 'Train No',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'ORG',
          value: 'org'
        },
        {
          text: 'Sch Dep.',
          value: 'dep'
        },
        {
          text: 'DEST',
          value: 'dest'
        },
        {
          text: 'Sch Arr.',
          value: 'arr'
        },
        {
          text: 'Rake No',
          value: 'device_name'
        },
        {
          text: 'Attachment Lag',
          value: 'insert_lag'
        },
        {
          text: 'Added At',
          value: 'insert_time_local'
        },
        {
          text: 'Auto Attached',
          value: 'auto_attach'
        },
        {
          text: 'Actions',
          align: 'right',
          value: 'action',
          sortable: false
        },
      ],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      summary: {},
      summary_all: {}
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate',]),
  },
  created() {
    this.train_date= this.curTrainDate || moment().format('YYYY-MM-DD'),
    this.initialize(false)
  },

  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate']),
    initialize(calcall) {
      this.menu1 = false
      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      this.isLoading = true
      this.trains = []
      var p = {
        train_date: this.curTrainDate,
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/attachment_report`, {
          params: p
        })
        .then(response => {
          // console.log(response);
          this.trains = response.data
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })

        axios.get(`${process.env.VUE_APP_API_URL}/train/tr/attachment_summary`, {
            params: p
          })
          .then(response => {
            this.summary = response.data
            console.log(this.summary);
          })
          .catch(e => {
            console.log(e)
          })
          var p1 = {
            train_date: this.curTrainDate,
            all: true
          }
          axios.get(`${process.env.VUE_APP_API_URL}/train/tr/attachment_summary`, {
              params: p1
            })
            .then(response => {
              this.summary_all = response.data
              console.log(this.summary_all);
            })
            .catch(e => {
              console.log(e)
            })
    },
    onRowClick($event) {
      console.log($event);
      if (item.device_id) {
        this.updateCurTrainNo($event.train_no)
        this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
        this.updateCurDeviceId($event.device_id)
        this.updateCurDeviceName($event.device_name)
        this.updateCurOrg($event.org)
        this.updateCurDep($event.dep)
        this.updateActDep($event.act_dep)
        this.updateCurDest($event.dest)
        this.updateCurArr($event.arr)
        this.updateActArr($event.act_arr)
        this.$router.push({
          name: 'Positions'
        })
      }
    },
    editTrains(item) {
      if (item.device_id) {
        this.updateCurDeviceId(item.device_id)
        this.updateCurDeviceName(item.device_name)
        this.$router.push({
          name: 'Trains'
        })
      }
    },
    getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--') {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("HH:mm:ss")
      }
    },
    getFormattedDateTime(t) {
      if (t != null) {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },
    getColour(item) {
      if (item.insert_lag <= 0) {
        return "orange"
      } else {
        return "green"
      }
    }
  }
}
</script>
